export const showTitle = (item, vm) => {
  // 显示面包屑
  // return vm.$config.useI18n ? vm.$t(item.name) : ((item.meta && item.meta.title) || item.name)

  // const lang = localStorage.getItem('local')
  const langLocale = JSON.parse(localStorage.getItem('langLocale'))
  return vm.$config.useI18n ? langLocale[item.name] : ((item.meta && item.meta.title) || item.name)
}
